import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TokenManagerService } from 'src/app/core/services/token-manager.service';
import { HttpStatus } from 'src/app/shared/constants/app.constant';
import { Router } from '@angular/router';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor(
    private tokenManagerService: TokenManagerService,
    private router: Router
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.tokenManagerService.getToken()}`
      }
    });

    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMsg = '';
          if (error.status === HttpStatus.Unauthorized && !error.url.includes('signin')) {
            this.tokenManagerService.clearLocalStorage();
            window.location.href = '/';
          } else {
            console.log('this is server side error');
            errorMsg = error.error?.Message || error.error;
          }
          return throwError(errorMsg);
        })
      );
  }
}
